import * as React from "react";
import { PrimaryModal } from "Components/Shared/PrimaryModal";
import { Resources, useResource } from "Translations/Resources";
import { Typography } from "@material-ui/core";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import {
  closeCompanyContactPersonDeleteModal,
  deleteCompanyContactAsync,
} from "State/Companies/CompanyReducer";
import { RootStateType } from "State/Store";
import { isNoU } from "Utils/ObjectUtils";

const StyledModalBody = styled.div`
  margin-bottom: ${props => props.theme.spacing(4)}px;

  & > * {
    &:last-of-type {
      font-weight: 500;
    }
  }
`;

export const CompanyContactDeleteConfirmModal: React.FunctionComponent = () => {
  const { t } = useResource();
  const dispatch = useDispatch();
  const { deletingCompanyContactID } = useSelector(
    (e: RootStateType) => e.companies,
  );

  const handleClose = () => {
    dispatch(closeCompanyContactPersonDeleteModal());
  };

  const handleSuccess = () => {
    if (deletingCompanyContactID) {
      dispatch(deleteCompanyContactAsync.request(deletingCompanyContactID));
    }
  };

  return (
    <>
      <PrimaryModal
        open={!isNoU(deletingCompanyContactID)}
        onClose={handleClose}
        onSuccess={handleSuccess}
        successBtnText={t(Resources.Common.Delete)}
        closeBtnText={t(Resources.Common.Cancel)}
        title={"Smazání kontaktu"}
      >
        <StyledModalBody>
          <Typography>Opravdu chcete smazat tento kontakt?</Typography>
        </StyledModalBody>
      </PrimaryModal>
    </>
  );
};
